var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessagesAnalyticsIcon = function SvgMessagesAnalyticsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.94c0 .584-.476 1.06-1.06 1.06H10l-3 2v-2H3.06C2.476 15 2 14.524 2 13.94V7.059C2 6.475 2.476 6 3.06 6h14.88c.584 0 1.06.475 1.06 1.059zM17.94 5H3.06A2.06 2.06 0 0 0 1 7.059v6.881A2.06 2.06 0 0 0 3.06 16H6v1.226a1 1 0 0 0 1.521.861L11 16h6.94A2.06 2.06 0 0 0 20 13.94V7.059A2.06 2.06 0 0 0 17.94 5M14.5 9a1.5 1.5 0 1 0-.001 2.998 1.5 1.5 0 0 0 .001-2.999zm-4-.001a1.5 1.5 0 1 0-.079 2.998A1.5 1.5 0 0 0 10.5 9m-4 0a1.5 1.5 0 1 0-.078 2.999A1.5 1.5 0 0 0 6.5 8.999"
  })));
};
export default SvgMessagesAnalyticsIcon;